export default "__VITE_ASSET__eb579fd3__"